module.exports = __webpack_public_path__ + "static/media/Faye Sun.cdb5da54.png";